import { UPGRADES_MAP } from '@flows/configs/contents/constants'
import type { ContentsNeoStepConfigParams } from '@flows/configs/contents/types'
import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'

const contents_natural_disasters = (params: ContentsNeoStepConfigParams) =>
  ({
    stepContent: [
      {
        type: 'title',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_contents:steps.contents.new.natural_disaster.title',
        },
      },
      {
        type: 'choice',
        shouldTrackValues: true,
        name: `product_keys.${UPGRADES_MAP.naturalDisasterProductKey[params.productKey]}`,
        options: [
          {
            label: {
              type: 'translatableText',
              translationKey: 'sharedFlows_common:steps.extension.yes',
            },
            value: true,
          },
          {
            label: {
              type: 'translatableText',
              translationKey: 'sharedFlows_common:steps.extension.no',
            },
            value: false,
          },
        ],
      },
      {
        type: 'infoBox',
        contentConfiguration: [
          {
            type: 'text',
            text: {
              type: 'translatableText',
              translationKey: 'sharedFlows_contents:steps.contents.new.natural_disaster.infoBox',
            },
          },
        ],
      },
    ],
    subFlow: params.subFlow,
    nextStep: 'contents_location',
  }) as const satisfies AnyStepConfiguration

export default contents_natural_disasters
